import { UploadIcon } from "../../icons";
import styles from "./ImporterPage.module.scss";

export const ImporterUploadPrompt: React.FC = () => (
    <div className={styles.uploadPrompt}>
        <UploadIcon
            className="icon-color-current mr-2"
            width="12"
            height="12"
        />
        Upload or drop in bank statements
    </div>
);
